import React, { FC, useEffect, useState } from 'react';
import { __AddCardNumberModalProps } from './addCardNumberModal.interface';
import { SiPayModal } from 'utilities/components';
import { Button, Input } from '30pay/components';
import { detectBank, detectBankByIBan, detectBankByName, faNumToEnNum, persianDigit, post } from 'scripts';
import { BankIcon } from 'utilities/components';
import { BsFillInfoSquareFill } from 'react-icons/bs';
import { API } from 'data/30pay.api';
import { Checkbox } from 'antd';

export const AddCardNumberModal: FC<__AddCardNumberModalProps> = (props: __AddCardNumberModalProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    const [cardNumber, setCardNumber] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const [isAddingIBanCheckpoint, setIsAddingIBanCheckpoint] = useState(false);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    const formatCardNumber = (input: string) => {
        // Remove non-digit characters and limit to 16 digits
        const digits = input.replace(/\D/g, '').slice(0, 16);

        // Format the digits into groups of four
        const formatted = digits.replace(/(\d{4})(?=\d)/g, '$1 - ').trim();

        return formatted;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = faNumToEnNum(e.target.value);
        const formattedValue = formatCardNumber(inputValue);
        setCardNumber(formattedValue);
    };

    function submitHandler() {
        setLoading(true);
        const parsedCardNumber = cardNumber.replaceAll(' - ', '');
        const body = { cardNumber: parsedCardNumber, addIBan: isAddingIBanCheckpoint };
        post(API.bankAccount.addCardNumber, body)
            .then((_) => {
                props.onFinish(body);
            })
            .catch((e) => console.log(e))
            .finally(() => setLoading(false));
    }

    return (
        <SiPayModal maxWidth={400} isOpen={isOpen} onClose={props.onClose} title="افزودن شماره کارت">
            <h4 className="font-bold text-base text<-darkPurple-100 mb-2 max-lg:text-sm">شماره کارت:</h4>
            <div style={{ direction: cardNumber ? 'ltr' : 'rtl' }}>
                <Input
                    prefix={<BankIcon symbol={detectBank(cardNumber)?.bank_name} />}
                    type="text"
                    value={cardNumber}
                    onChange={handleChange}
                    placeholder="مثال: ۱۲۳۴ - ۴۵۶۷ - ۷۸۹۱ - ۱۲۳۴"
                    onPressEnter={submitHandler}
                />
            </div>
            <div className="flex items-center gap-2 my-5">
                <BsFillInfoSquareFill className={'text-warning-light'} />
                <p className="font-medium text-sm text-darkPurple-100">شماره کارت باید به نام صاحب حساب کاربری باشد!</p>
            </div>
            <div
                onClick={() => setIsAddingIBanCheckpoint(!isAddingIBanCheckpoint)}
                className="flex items-center gap-2 my-5"
            >
                <Checkbox
                    checked={isAddingIBanCheckpoint}
                    onChange={(e) => setIsAddingIBanCheckpoint(e.target.checked)}
                />
                <p className="font-medium text-sm text-darkPurple-100">شماره شبا این کارت هم هم افزوده شود.</p>
            </div>
            <Button
                disabled={cardNumber.replaceAll(' - ', '').length < 16}
                loading={loading}
                onClick={submitHandler}
                className="mt-6 w-full"
                type="primary"
            >
                افزودن شماره کارت
            </Button>
        </SiPayModal>
    );
};
